import styled from "styled-components";

export const LiteTradeNotificationCloseAllStyled = styled.div`
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    font-size: 20px;
    font-weight: 600;
    z-index: 1210;
    text-align: center;
    color: var(--color-label-primary);
    
    svg {
        fill: var(--color-button-primary-default);
    }
`;
